import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
const apiAxios = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

Vue.use(Vuex, apiAxios)
var token_pub = 'fasdfeqrw42345234523234'
export default new Vuex.Store({
  state: {
    notification: {
      estado: false,
      mensaje: ''
    },
    cargando: {
      estado: false
    }
  },
  mutations: {
    setNotification(state, payload){
      state.notification.estado = payload.estado;
      state.notification.mensaje = payload.mensaje;
    },
    setCargando(state, payload){
      state.cargando.estado = payload.estado;
    }
  },
  actions: {
    fetchUsuarios ({ commit }, payload) {
      payload.token_pub = token_pub
      let usuario = localStorage.getItem('infoUsuario')
      if (usuario != null && usuario !== undefined && usuario !== '') {
        usuario = JSON.parse(usuario)
        payload.token_pri = usuario.token
        payload.email = usuario.email
        return axios.post('/../ausuarios/usuarios_obtener', payload).then((result) => {
          return result.data
        })
      } else {
        return null
      }
    },

    fetchCertificacionesPendientes ({ commit }, payload) {
      payload.token_pub = token_pub
      let usuario = localStorage.getItem('infoUsuario')

      if (usuario != null && usuario !== undefined && usuario !== '') {

        usuario = JSON.parse(usuario)
        payload.token_pri = usuario.token
        payload.email = usuario.email

        return axios.post('/../acertificados/certificaciones_pendientes', payload).then((result) => {
          return result.data
        })
      } else {
        return null
      }
    },

    changePass ({ commit }, payload) {
      payload.token_pub = token_pub
      let usuario = localStorage.getItem('infoUsuario')
      if (usuario != null && usuario !== undefined && usuario !== '') {
        usuario = JSON.parse(usuario)
        payload.token_pri = usuario.token
        payload.email = usuario.email
        return axios.post('/../login/cambiar_pass', payload).then((result) => {
          return result.data
        })
      } else {
        return null
      }
    },
    manifestarInteres({ commit }, payload){
      return axios.post('/../ofertas/manifestar_interes_pub', payload).then((result) => {
        return result.data
      })
    },
  },
  modules: {
  },
  getters: {
    getNotification: state => {
      return state.notification;
    },
    getCargando: state => {
      return state.cargando;
    }
  }
})
